import {
  useQueryClient,
  useQuery,
  useMutation,
  keepPreviousData,
} from "@tanstack/react-query";
import { errorMessage, successMessage } from "../../../utils/helper";
import { getSyncHistoryDetails } from "../api/PosSyncApi";
import qs from "qs";

const syncHistoryDetailsKeys = {
  all: ["syncHistoryDetails"],
  detail: (id) => [...syncHistoryDetailsKeys.all, id],
};

export const useSyncHistoryDetailsQueries = ({ syncID }) => {
  const queryClient = useQueryClient();

  const syncDetails = useQuery({
    queryKey: syncHistoryDetailsKeys.detail(syncID),
    queryFn: () => getSyncHistoryDetails({ id: syncID }),
    enabled: syncID > 0,
  });

  return {
    syncDetails,
  };
};
